import { AuthService } from '../services';
import {
  RoleConfigActionsMapInterface,
  RoleConfigInterface,
  RoleConfigTagsInterface,
} from '../store/types';
import { HandleGetUserByCodeUtilityInterface } from './types';

export const handleGetUserByCode: HandleGetUserByCodeUtilityInterface = async ({
  emailParam,
  codeParam,
  stopLoadingOnSuccess = true,
  setLoading,
  setExpired,
  setProfile,
}) => {
  try {
    const response = await AuthService.getUserByCode({
      code: codeParam,
      emailId: emailParam,
    });
    if (response) {
      if (stopLoadingOnSuccess) {
        setLoading(false);
      }
      if (setProfile) {
        setProfile(response);
      }
    }
  } catch (error) {
    setLoading(false);
    setExpired(true);
  }
};

export const handleSetEntityName = async (
  setRoleConfig: (config: RoleConfigInterface | null) => void,
  setRoleConfigTags: (tags: RoleConfigTagsInterface | null) => void,
  setRoleConfigActions: (actions: RoleConfigActionsMapInterface | null) => void
) => {
  try {
    const response = await AuthService.getUserAccess();
    if (response) {
      const { moduleConfigResponseMap, tags } = response;
      setRoleConfig(moduleConfigResponseMap);
      setRoleConfigTags(tags);
      const roleConfigActions = Object.values(moduleConfigResponseMap ?? {})
        .filter((actionItems) => actionItems && actionItems.actions)
        .map((config) => Object.values(config.actions))
        .flat()
        .reduce((result: RoleConfigActionsMapInterface, actionItem: any) => {
          if (actionItem) {
            result[actionItem.actionId] = actionItem;
          }
          return result;
        }, {});
      setRoleConfigActions(roleConfigActions);
    }
  } catch (error) {
    console.error('Error in handleSetEntityName', error);
  }
};
